import { useIntl } from 'react-intl'
import { deviceApi } from '@/api/deviceApi'
import {
  FilterSelectAsync,
  FilterSelectAsyncProps
} from '@/components/ui-shared/Tables/FilterSelect/FilterSelectAsync'
import { deviceQueryKeys } from '@/queries/deviceQueries'
import { Device } from '@/types/device'
import { PaginatedResponse } from '@/types/pagination'
import { MAX_ITEMS_WITHOUT_PAGINATION } from '@/utils/pagination'

const params = {
  limit: MAX_ITEMS_WITHOUT_PAGINATION,
  ordering: 'label'
}

type DeviceFilterProps = Pick<
  FilterSelectAsyncProps<Device, PaginatedResponse<Device[]>>,
  'value' | 'onChange'
>

export const DeviceFilter = ({ value, onChange }: DeviceFilterProps) => {
  const intl = useIntl()

  return (
    <FilterSelectAsync<Device, PaginatedResponse<Device[]>>
      width={220}
      value={value}
      queryFn={() => deviceApi.getDeviceList(params)}
      queryKey={deviceQueryKeys.list(params)}
      selectFn={(data) => data.results}
      getOptionValue={(device) => device.id}
      getOptionLabel={(device) => device.label}
      placeholder={intl.formatMessage({
        id: 'cameras.list.filter.device.placeholder'
      })}
      onChange={onChange}
    />
  )
}
